module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.history')))]), _vm._v(" "), _c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.usage')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.activeTab == 0) ? _c('help-popover', {
    staticClass: "mr-4 mt-2"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('help.history')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.activeTab == 1) ? _c('help-popover', {
    staticClass: "mr-4 mt-2",
    attrs: {
      "color": "success"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('help.usage')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('treatment-logs', {
    attrs: {
      "relationship-id": _vm.relationshipId
    }
  })], 1), _vm._v(" "), _c('v-tab-item', [_c('historical-usage', {
    attrs: {
      "client-id": _vm.clientId,
      "relationship-id": _vm.relationshipId
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04b7ef16","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientCodes.vue
// module id = 1313
// module chunks = 9